import { Section } from 'tio-reimagined/components/layout';
import { t } from 'ember-intl';
import TioFaqs from '../../tio/faqs.gts';
import type { TOC } from '@ember/component/template-only';
import type TasProgramTemplateModel from 'tio-data/models/tas-program-template';

interface TasAppDetailsApproverOverviewSig {
  Args: {
    programTemplate: TasProgramTemplateModel;
  };
}

const TasAppDetailsApproverOverview: TOC<TasAppDetailsApproverOverviewSig> = <template>
  <Section>
    <:header>
      {{@programTemplate.programName}}
      {{t "tuition_assistance.application_details.overview"}}
    </:header>
    <:body>
      <article>
        <h3 class="font-semibold leading-6">
          {{t "tuition_assistance.application_details.approver_instructions"}}
        </h3>
        <ul>
          {{#each @programTemplate.programApproverInstructions as |instruction|}}
            <li class="my-2 tracking-wide">
              <h3 class="font-semibold leading-6">
                {{t "tuition_assistance.application_details.instruction"}}
                {{instruction.ordinal}}:
              </h3>
              <p class="mt-1 text-sm tio-fg-muted">
                {{instruction.body}}
              </p>
            </li>
          {{/each}}
        </ul>
      </article>

      <article>
        <h3 class="font-semibold leading-6 mt-3">
          {{t "tuition_assistance.faq"}}
        </h3>
        {{#each @programTemplate.programFaqs as |faq|}}
          <TioFaqs @question={{faq.heading}} @answer={{faq.body}} class="mt-3" />
        {{/each}}
      </article>
    </:body>
  </Section>
</template>;

export default TasAppDetailsApproverOverview;
